import styled from 'styled-components';
import theme from 'src/theme';

type Props = {
    gridCol?: number;
    gridColSpan?: number;
    isHalfWidth?: boolean;
    gridCols?: number;
    resetCols?: boolean;
};
export const HeadingWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    height: 50px;
    background: ${theme.legacyColors.selectedBackground};
    color: ${theme.legacyColors.selectedColor};
    border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
`;

export const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    margin-bottom: 5px;
`;

export const ChemicalCategory = styled.div`
    margin: 0 0 10px 0;
`;

export const ChemicalItem = styled.li`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    margin-bottom: 5px;
`;

export const PanelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dae3c8;
    font-size: 0.9rem;
    font-weight: 500;
    align-items: flex-start;
    height: 60px;
    padding: 10px;
    margin: 0 0 10px;
`;

export const Heading3 = styled.h3`
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
    background: #f4f4f4;
    border-bottom: 1px solid #00447e;
    padding: 5px 0;
    .info-icon {
        margin: 0 0 0 3px;
        color: #04265a;
    }
`;

export const ChemicalOrderItemRow = styled.div`
    display: grid;
    grid-template-columns: 2fr repeat(4, minmax(10px, 1fr));
    grid-column-gap: 0.5rem;
    justify-items: flex-end;
    padding: 0 10px;
    .current-order {
        margin: 0 35px 0 0;
    }
    .category-col {
        justify-self: flex-start;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    grid-gap: 0.5rem;
    position: relative;
    border-bottom: 1px solid #ccc;
    height: 51px;
    align-items: center;
    .choose-order-tab-menu {
        display: flex;
        justify-content: flex-start;
        flex: 0 0 auto;
    }
`;

export const LeftContentWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem 0 0;
    flex: 0 0 auto;
    padding: 7px 7px 0px 7px;
`;

export const MiddleContentWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem 0 0;
    flex: 0 0 auto;
`;

export const RightContentWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px 0 10px;
`;

export const ChemicalCategoryInputsWrapper = styled.div`
    ul {
        width: 100%;
        margin: 5px 0 0 0;
    }
`;

export const ChemicalOrderWrapper = styled.div`
    font-size: 0.8rem;
    height: calc(100% - 60px);
    overflow-y: auto;
`;

export const ProcessButtonWrapper = styled.div`
    margin: 0 0 0 15px;
    display: grid;
    grid-gap: 0.1rem;
    grid-template-columns: auto auto;
    padding: 0 0 0 15px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 10px;
`;

export const ListValuesWrapper = styled.div<Props>`
    select {
        border: 1px solid #ccc;
        height: 1.5rem;
        border-radius: 3px;
        width: 115px;
    }

    .aggr-rob {
        font-weight: 500;
    }
`;

export const StatusText = styled.span<Props>`
    padding: 0px 8px 0 8px;
    border-radius: 40px;
    font-weight: 500;
    font-size: 0.7rem;
    line-height: 1.4rem;
    display: inline-block;
    width: max-content;
    background: #e7e7e7;
    color: #b1b1b1;
    height: 20px;
    line-height: 1.25rem;
    margin: 0 3px 0 0;

    &.status-draft {
        color: #333;
        background: #ccc;
    }
    &.status-sent-to-operator {
        color: #fff;
        background: #f5ab23;
    }
    &.status-ordered {
        color: #223804;
        background: #c4dfa0;
    }
    &.status-confirmed {
        color: #fff;
        background: #107c10;
    }

    &.status-canceled {
        color: #fff;
        background: black;
    }
`;

export const StatusAdditionalText = styled.span<Props>`
    color: #222;
    padding: 0 5px;
    font-weight: 500;
    font-size: 0.7rem;
`;

export const UpdateStatusText = styled.span<Props>`
    padding: 1px 7px;
    border-radius: 40px;
    font-weight: 500;
    font-size: 0.7rem;
    line-height: 1.4rem;
`;
export const OrderEditValue = styled.span`
    display: flex;
`;
